import React from 'react';
import Routes from './routes';
import { ThemeProvider } from './theme/ThemeContext';
import GlobalImportFailedModal from './components/GlobalImportFailedModal';

const App = () => {
  return (
    <ThemeProvider>
      <Routes />
      <GlobalImportFailedModal />
    </ThemeProvider>
  );
};

export default App;
